var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M21.707,5.15H17.74V4.734c0-1.674-1.36-3.035-3.032-3.035h-3.416c-1.672,0-3.033,1.361-3.033,3.035V5.15 H4.293c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.899,0.9,0.899h0.684v15.263c0,1.151,0.937,2.088,2.087,2.088h11.873 c1.15,0,2.087-0.937,2.087-2.088V6.95h0.684c0.497,0,0.9-0.402,0.9-0.899S22.204,5.15,21.707,5.15z M10.06,4.734 c0-0.681,0.553-1.235,1.232-1.235h3.416c0.68,0,1.231,0.555,1.231,1.235V5.15h-5.88V4.734z M19.223,22.213 c0,0.158-0.128,0.287-0.286,0.287H7.063c-0.158,0-0.286-0.129-0.286-0.287V6.95h12.445V22.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M9.539,20.484c0.497,0,0.9-0.403,0.9-0.9v-8.865c0-0.497-0.403-0.9-0.9-0.9s-0.9,0.403-0.9,0.9v8.865 C8.639,20.081,9.042,20.484,9.539,20.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M12.999,20.484c0.497,0,0.9-0.403,0.9-0.9v-8.865c0-0.497-0.403-0.9-0.9-0.9s-0.9,0.403-0.9,0.9v8.865 C12.099,20.081,12.502,20.484,12.999,20.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M16.46,20.484c0.497,0,0.9-0.403,0.9-0.9v-8.865c0-0.497-0.403-0.9-0.9-0.9s-0.9,0.403-0.9,0.9v8.865 C15.56,20.081,15.963,20.484,16.46,20.484z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.851412f1.svg";
export { ForwardRef as ReactComponent };